import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const ExpansionName = styled(Typography)`
  color: #fff;
`

ExpansionName.displayName = 'ExpansionName'

export default ExpansionName
